import { useEffect, useRef } from 'react';
import { useActionWhenScrollToView } from '@/utils/index'
// import anime from 'animejs/lib/anime.es.js';
import { CountUp } from 'countup.js';

export const useAutoSlide = (ref, toLeft) => {
  const fn = (init = false) => {
    const current = ref.current
    const parent = current.parentNode
    const firstChild = current.firstElementChild
    if (init && parent.clientWidth >= firstChild.clientWidth) {
      return
    }
    const distance = firstChild.clientWidth
    let transformX = toLeft ? -distance : distance
    if (init) {
      current.addEventListener('transitionend', async () => {
        current.style.transition = ''
        current.style.transform = 'none'
        // move first child to the end
        current.appendChild(current.firstElementChild);
        fn()
      })

      const cloneChild = firstChild.cloneNode(true)
      cloneChild.classList.add('item2')
      current.appendChild(cloneChild)
    }
    current.style.transition = `transform ${distance / 100 * 1.5}s linear 0s`
    current.style.transform = `translateX(${transformX}px)`
  }
  useEffect(() => {
    setTimeout(() => {
      if (!ref || !ref.current) {
        return
      }

      fn(true)
    }, 1500);
  }, [])
}

export const NumberAnime = ({ num, justPlayOnce = true, duration = 2 }) => {
  const numRef = useRef(null)
  useActionWhenScrollToView(numRef, (target) => {
    // https://github.com/inorganik/countUp.js
    const numAnim = new CountUp(target, num, { decimalPlaces: 2, duration });
    numAnim.start()
    
    // https://github.com/juliangarnier/anime
    // anime({
    //   targets: target, 
    //   innerHTML: [0, num],
    //   easing: 'easeInOutExpo',
    //   round: decimal,
    //   duration
    // });
  }, justPlayOnce)

  return (
    <strong ref={numRef}></strong>
  );
}
